const buildKnowledgeHubDocUrl = (workspaceId, docId) => {
  if (!workspaceId || !docId) return null;
  return `/workspaces/${workspaceId}/mrc_contents/${docId}`;
};

export default buildKnowledgeHubDocUrl;
